// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"6127":"css/app.6953","6996":"css/admin-app.6953"}[chunkId] + ".css";
};